import React from "react";
import { Drawer } from "antd";
import ExportCSVReport from "../../../../components/ExportCSVReport";
import moment from "moment";

const ViewReport: React.FC<any> = (props) => {
  const { handleViewReport, openUpdateModal, openUpdateData } = props;

  let viewData = openUpdateData?.response
    ? JSON.parse(openUpdateData?.response)
    : null;

  viewData = viewData.map((ele) => {
    return {
      ...ele,
      created: moment(ele.created).format("YYYY-MM-DD hh:mm:ss a"),
      updated: moment(ele.updated).format("YYYY-MM-DD hh:mm:ss a"),
    };
  });
  const tableArray = (data: any) => {
    // Ensure the data is wrapped in an array for consistent processing
    const dataArray = Array.isArray(data) ? data : [data];

    return (
      <>
        <thead>
          <tr>
            <th>Row Id</th>
            <th>Shorthand Number</th>
            <th>Phone Number</th>
            <th>Shadow Number</th>
            <th>Created</th>
            <th>Updated</th>
          </tr>
        </thead>
        <tbody>
          {dataArray.length > 0 ? (
            dataArray.map((item: any, index: number) => (
              <tr key={index}>
                <td>{item.row_id}</td>
                <td>{item.shorthand_number}</td>
                <td>{item.phone_number}</td>
                <td>{item.shadow_number}</td>
                <td>{item.created}</td>
                <td>{item.updated}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5}>No Data Found</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  return (
    <Drawer
      open={openUpdateModal}
      destroyOnClose
      width={900}
      onClose={handleViewReport}
      footer={
        viewData ? (
          <div className="text-right">
            <ExportCSVReport
              elements={viewData}
              reportName={`asterisk-number-by-shadow-prefix-${openUpdateData.prefix}-${Date.now()}`}
              label={true}
            />
          </div>
        ) : (
          false
        )
      }
      className="addModal"
      title={`View Report`}
    >
      <table className="reportTable" width={"100%"}>
        {tableArray(viewData)}
      </table>
      {/* {viewData?.length > 0 ? viewData.map((item: any) => monthlyData(item)) : null} */}
    </Drawer>
  );
};

export default ViewReport;
